import { TranslationMessages } from 'react-admin';
import englishMessages from 'ra-language-english';

const customEnglishMessages: TranslationMessages = {
    ...englishMessages,
    map: {
        show_traffic_label: "Show Traffic",
        hybrid_view_label: "Hybrid View",
        legend: {
            in_parking: "In Parking",
            with_passager: "With Passager",
            to_pickup: "To Pickup",
            free_taxi: "Free Taxi"
        }
    },
    orders: {
        name: "Orders",
        new_order_label: "New Order",
        client_details: "Client details",
        client_name: "Client Name",
        client_phone: "Client Phone"
    },
    devices: {
        name: "Devices"
    },
    reservations: {
        name: "Reservations"
    },
    fixet_routes: {
        name: "Fixed Routes"
    },
    vehicles: {
        name: "Vehicles"
    },
    drivers: {
        name: "Drivers"
    },
    users: {
        name: "Users"
    },
    notifications: {
        name: "Notifications"
    },
    timeoff_pending: {
        name: "Pending Requests"
    },
    expenses: {
        name: "Expenses"
    },
    incomes: {
        name: "Incomes"
    },
    reminders: {
        name: "Reminders"
    },
    service: {
        name: "Service"
    },
    services: {
        name: "Services"
    },
    refueling: {
        name: "Refueling"
    }, 
    inventory: {
        name: "Inventory"
    },
    branches: {
        name: "Branches"
    },
    clients: {
        name: "Clients"
    },
    vehicle: {
        name: "Vehicles",
        classes: "Vehicle Classes",
    },
    pricing: {
        name: "Pricing"
    },
    appointments: {
        name: "Appointments"
    },
    userManagment: {
        name: "Manage users"
    },
    serviceReports: {
        name: "Reports"
    },
    invoice: {
        name: "Invoices"
    },
    report: {
        name: "Reports"
    }
};

export default customEnglishMessages;